import dayjs from 'dayjs'
import { changeTimeLocalToUtc } from '../../../helper'
import { DATE_FORMAT } from '../../../utils/constants'

export class DealVanilla {
  constructor(form, currencyNormalize = {}, tradingAccountPrimeBrokerNormalize = {}) {
    this.deal_type = form.deal_type.name
    this.client_side = form.client_side
    this.base_currency = form.currency_pair.substring(0, 3)
    this.counter_currency = form.currency_pair.substring(3, 6)
    this.client = form.client
    this.market_maker = form.market_maker
    this.trade_date = changeTimeLocalToUtc(form.trade_date, DATE_FORMAT.REGULAR_DATE_TIME)
    this.quantity = Number(form.quantity)
    this.client_premium_amount = Number(form.client_premium_amount)
    this.market_maker_premium_amount = Number(form.market_maker_premium_amount)
    this.client_premium_currency = form.client_premium_currency.name
    this.market_maker_premium_currency = form.market_maker_premium_currency.name
    if (
      currencyNormalize.data &&
      (currencyNormalize?.data[this.base_currency]?.is_ndf ||
        currencyNormalize?.data[this.counter_currency]?.is_ndf)
    ) {
      this.fixing_date = dayjs(form.expiry).format(DATE_FORMAT.REGULAR_DATE)
      this.fixing_source = form.fixing_source
    }
    this.client_premium_date = form.client_premium_date
      ? dayjs(form.client_premium_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.market_maker_premium_date = form.market_maker_premium_date
      ? dayjs(form.market_maker_premium_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''

    this.put_call = form.put_call
    this.settlement_date = form.settlement_date
      ? dayjs(form.settlement_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.expiry = form.expiry ? dayjs(form.expiry).format(DATE_FORMAT.REGULAR_DATE) : ''
    this.strike = Number(form.strike)
    this.cut = form.cut
    this.client_trader_name = form.client_trader_name
    this.market_maker_trader_name = form.market_maker_trader_name
    this.client_note = form.client_note
    this.market_maker_note = form.market_maker_note
    if (
      this.client &&
      this.market_maker &&
      tradingAccountPrimeBrokerNormalize?.data?.trading_account_prime_broker?.[this.client]
        ?.prime_broker === 'RBS' &&
      tradingAccountPrimeBrokerNormalize?.data?.trading_account_prime_broker?.[this.market_maker]
        ?.prime_broker === 'RBS'
    ) {
      this.bdr = form.bdr
      this.is_structure = form.is_structure
      this.is_pba = form.is_pba
    }
    this.trade_origin = 'FXER'
  }
}
